module.exports = __webpack_public_path__ + "img/5.46d024b9.jpg";